import { render, staticRenderFns } from "./newUserTipModal.vue?vue&type=template&id=26deafc6&"
import script from "./newUserTipModal.vue?vue&type=script&lang=ts&"
export * from "./newUserTipModal.vue?vue&type=script&lang=ts&"
import style0 from "./newUserTipModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports